// ─────────────────────────────────────────────────────────────────────────────
// useLayoutSelect.ts — Shared "pick a CV layout" behaviour
//
// Selecting a layout also auto-applies its suggested colour scheme (if any).
// Shared between the desktop ThemeSelector dropdown and the mobile Customize
// sheet so this side effect never has to be duplicated.
// ─────────────────────────────────────────────────────────────────────────────

import { useAppDispatch } from '@/hooks';
import { setCVLayout, setColourScheme } from '@/store/uiSlice';
import type { LayoutOption } from '@/data/navOptions';

export function useLayoutSelect() {
  const dispatch = useAppDispatch();

  return (layout: LayoutOption) => {
    dispatch(setCVLayout(layout.value));
    if (layout.defaultScheme) {
      dispatch(setColourScheme(layout.defaultScheme));
    }
  };
}
